import { TbReportSearch } from "react-icons/tb";
import { AiFillSignal } from "react-icons/ai";
import { AiFillHome } from "react-icons/ai";
import { BiUserPlus } from "react-icons/bi";
import { HiClipboardDocumentList } from "react-icons/hi2";
import { IoNotificationsCircleSharp } from "react-icons/io5";
import { TbTableOptions } from "react-icons/tb";
import { Link, useNavigate } from "react-router-dom";
import "./NarvBarLeft.css";

const NavbarLeft = () => {
  const navigate = useNavigate();

  const handleClearData = () => {
    sessionStorage.removeItem("reportData");
  };

  const handleData = () => {
    const storedData = sessionStorage.getItem("reportData");
    if (storedData) {
      const data = JSON.parse(storedData);
      navigate("/lealtad/detalle-ingresos-egresos", { state: { data } });
    }
  };

  return (
    <div className="allheaderleft-lealtad">
      <Link style={{ textDecoration: "none" }} to="/inicio-lealtad">
        <div className="button-index-left-lealtad" onClick={handleClearData}>
          <div className="container-text-icons-lealtad">
            <AiFillHome className="icon-button-left-lealtad" />
            <p className="text-button-left-in-lealtad">Home</p>
          </div>
        </div>
      </Link>
      <Link style={{ textDecoration: "none" }} to="/lealtad/informe">
        <div className="button-index-left-lealtad">
          <div className="container-text-icons-lealtad">
            <TbReportSearch className="icon-button-left-lealtad" />
            <p className="text-button-left-in-lealtad">Informe</p>
          </div>
        </div>
      </Link>
      <Link style={{ textDecoration: "none" }} to="/lealtad/detailMDR">
        <div className="button-index-left-lealtad">
          <div className="container-text-icons-lealtad">
            <AiFillSignal className="icon-button-left-lealtad" />
            <p className="text-button-left-lealtad">Matriz de Riesgo</p>
          </div>
        </div>
      </Link>
      <Link style={{ textDecoration: "none" }} to="/lealtad/crear-relacion">
        <div className="button-index-left-lealtad">
          <div className="container-text-icons-lealtad">
            <BiUserPlus className="icon-button-left-lealtad" />
            <p className="text-button-left-lealtad">
              Crear <br /> Relación
            </p>
          </div>
        </div>
      </Link>
      <Link style={{ textDecoration: "none" }} to="/lealtad/alertas">
        <div className="button-index-left-lealtad">
          <div className="container-text-icons-lealtad">
            <IoNotificationsCircleSharp className="icon-button-left-lealtad" />
            <p className="text-button-left-lealtad">Alertas</p>
          </div>
        </div>
      </Link>
      <Link style={{ textDecoration: "none" }} to="/lealtad/edit-matriz">
        <div className="button-index-left-lealtad">
          <div className="container-text-icons-lealtad">
            <TbTableOptions className="icon-button-left-lealtad" />
            <p className="text-button-left-lealtad">Variables de Matriz</p>
          </div>
        </div>
      </Link>
      <Link
        style={{ textDecoration: "none" }}
        to="/lealtad/detalle-ingresos-egresos"
      >
        <div className="button-index-left-lealtad" onClick={handleData}>
          <div className="container-text-icons-lealtad">
            <HiClipboardDocumentList className="icon-button-left-lealtad" />
            <p className="text-button-left-lealtad">
              Pagos <br /> y Cobros
            </p>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default NavbarLeft;
